module.exports = __webpack_public_path__ + "img/jrfw.18a6fedd.png";